export default "__VITE_ASSET__BEeopgp$__"